import RouteLayout, { RouteErrorLayout } from "components/Menu/components/RouteLayout";

import TilleyChatWorkspace from "../components/Tilley/TilleyChatWorkspace";

export const tilleyRoutes = [
  {
    path: "/tilley",
    element: <RouteLayout />,
    children: [{ index: true, element: <TilleyChatWorkspace /> }],
    errorElement: <RouteErrorLayout errorTitle="Hey, Tilley chat" />,
  },
];
